import React from 'react';
import { FaPhone, FaLinkedin, FaYoutube, FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Top Section */}
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-text">única</span>
              <span className="logo-accent">fácil</span>
            </div>
            <div className="logo-subtitle">DELIVERY OFICIAL</div>
          </div>
          
          <div className="security-badge">
            <div className="badge-content">
              <span className="badge-text">SITE BLINDADO</span>
              <span className="badge-subtext">AUDITADO EM 01-SET</span>
            </div>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-columns">
            {/* Payment Methods */}
            <div className="footer-column">
              <h3 className="footer-title">Formas de pagamento</h3>
              <p className="payment-description">
                Aceitamos pagamentos via cartão de crédito/débito, dinheiro e PIX.
              </p>
              <div className="payment-icons">
                <div className="payment-icon">💳</div>
                <div className="payment-icon">🏦</div>
                <div className="payment-icon">📱</div>
                <div className="payment-icon">💳</div>
              </div>
            </div>

            {/* Useful Links */}
            <div className="footer-column">
              <h3 className="footer-title">Links Úteis</h3>
              <ul className="footer-links">
                <li><a href="#sobre">Sobre o serviço</a></li>
                <li><a href="#contato">Fale conosco</a></li>
                <li><a href="#faq">Perguntas frequentes</a></li>
                <li><a href="#blog">Nosso blog</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-title">Políticas</h3>
              <ul className="footer-links">
                <li><a href="#privacidade">Política de privacidade</a></li>
                <li><a href="#seguranca">Política de Segurança da Informação</a></li>
                <li><a href="#etica">Canal de ética</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            {/* Contact & Social */}
            <div className="footer-contact">
              <div className="contact-info">
                <div className="phone-info">
                  <FaPhone className="phone-icon" />
                  <span>4020.5278</span>
                </div>
                <div className="service-hours">
                  Atendimento das 9h às 18h (dias úteis)
                </div>
              </div>
              
              <div className="social-links">
                <a href="#linkedin" className="social-link">
                  <FaLinkedin />
                </a>
                <a href="#youtube" className="social-link">
                  <FaYoutube />
                </a>
                <a href="#facebook" className="social-link">
                  <FaFacebook />
                </a>
                <a href="#twitter" className="social-link">
                  <FaTwitter />
                </a>
                <a href="#instagram" className="social-link">
                  <FaInstagram />
                </a>
              </div>
            </div>

            {/* Copyright & Address */}
            <div className="footer-legal">
              <div className="copyright">
                Copyright © 2025 - Acumuladores Única S. A.
              </div>
              <div className="company-info">
                <span>CNPJ: 01.098.290/0001-10</span>
                <span>Todos os direitos reservados.</span>
                <span>Rua Padre Carapuceiro, 706</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
